  // *********************************************************************************
  var ga4_tracker = {}

  ga4_tracker.data_push = function(obj){
    if(typeof dataLayer != 'undefined'){
      //dataLayer.push(obj);
      ga4_tracker.consent_push(obj);
    }else{
      console.log('No dataLayer. Would have pushed:');
      console.log(obj);
    }
  }

  ga4_tracker.consent_push = function(event_obj, retryCount = 0){
    // Check if 'OnetrustActiveGroups' object exists in the DataLayer
    if (typeof dataLayer !== 'undefined' && dataLayer.some(item => item.hasOwnProperty('OnetrustActiveGroups'))) {
      // Check if 'OneTrustLoaded' event object exists
      if (dataLayer.some(item => item.hasOwnProperty('event') && item.event === 'OneTrustLoaded')) {
        // Fire our event here.
        dataLayer.push(event_obj);
      } else if (retryCount < 10) {
        // Retry after 10 seconds, incrementing the retryCount
        setTimeout(function() {
          ga4_tracker.consent_push(event_obj, retryCount + 1);
        }, 4000);
      }
    } else if (retryCount < 10) {
      setTimeout(function() {
          ga4_tracker.consent_push(event_obj, retryCount + 1);
        }, 1000);
    }
  }

  ga4_tracker.add_to_cart = function(request){
    if(typeof request.responseJSON != 'undefined'){
      var currency = "GBP";
      if(Shopify.currency != 'undefined'){
        var currency = Shopify.currency.active;
      }
      
      let json = request.responseJSON;
      let data = {
                currency: currency,
                value: (json.price/100 * json.quantity), 
                items: [{
                  item_id: json.variant_id,
                  item_name: json.product_title,
                  item_brand: json.vendor,
                  item_category: json.product_type,
                  item_variant: json.variant_title,
                  price: json.price/100,
                  quantity: json.quantity
                }]
               };
       ga4_tracker.report_conversion(data);
    }else{
      console.log('no json');
    }
  }  
  
  ga4_tracker.remove_from_cart = function(line_item_key,line_item_qty) {
    var currency = "GBP";
    if(Shopify.currency != 'undefined'){
      var currency = Shopify.currency.active;
    }
    
    //we need to get the current cart data 
    jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;
      for(let n=0; n< items.length; n++){
        if(items[n].key == line_item_key){
          item = items[n];
          let data = {
                currency: currency,
                value: (item.price/100 * line_item_qty), 
                items: [{
                  item_id: item.variant_id,
                  item_name: item.product_title,
                  item_brand: item.vendor,
                  item_category: item.product_type,
                  item_variant: item.variant_title,
                  price: item.price/100,
                  quantity: line_item_qty
                }]
               };
          ga4_tracker.report_removal(data);
        }
      }
    });
  }

  ga4_tracker.add_from_cart = function(line_item_key,line_item_qty) {
    var currency = "GBP";
    if(Shopify.currency != 'undefined'){
      var currency = Shopify.currency.active;
    }
    
    //we need to get the current cart data 
    jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;
      for(let n=0; n< items.length; n++){
        if(items[n].key == line_item_key){
          item = items[n];
          let data = {
                currency: currency,
                value: (item.price/100 * line_item_qty), 
                items: [{
                  item_id: item.variant_id,
                  item_name: item.product_title,
                  item_brand: item.vendor,
                  item_category: item.product_type,
                  item_variant: item.variant_title,
                  price: item.price/100,
                  quantity: line_item_qty
                }]
               };
          ga4_tracker.report_conversion(data);
        }
      }
    });
  }

  ga4_tracker.report_conversion = function(data){
    ga4_tracker.data_push({ ecommerce: null });
    ga4_tracker.data_push({
      event: "add_to_cart",
      ecommerce: data
    });
  }
  
  ga4_tracker.report_removal = function(data){
    ga4_tracker.data_push({ ecommerce: null });
    ga4_tracker.data_push({
      event: "remove_from_cart",
      ecommerce: data
    });
  }

  ga4_tracker.track_step = function(event){
    var currency = "GBP";
    if(typeof Shopify.currency !== "undefined"){
      currency = Shopify.currency.active;
    }
    let data = {
                currency: currency,
                value: mhg.cart_value, 
                items: mhg.line_items
               };
    ga4_tracker.data_push({ ecommerce: null });
    ga4_tracker.data_push({
      event: event,
      ecommerce: data
    });
    console.log('ga4_tracker.track_step:');
    console.log(data);
  }
  ga4_tracker.step_shipping = function(){
    ga4_tracker.track_step('add_shipping_info');
  }
  ga4_tracker.step_payment = function(){
    ga4_tracker.track_step('add_payment_info');
  }
  ga4_tracker.step_purchase = function(){
    ga4_tracker.track_step('purchase');
  }
  // *********************************************************************************
  $(document).ajaxComplete(function(event, request, settings){
    if(settings.url == "/cart/add.js"){
        ga4_tracker.add_to_cart(request);
    }
  });
  // *********************************************************************************